import React, { useState, useEffect } from "react";
import { getContentData } from "./model/e_service";
import { useSelector } from "react-redux";
import { Link, Grid, makeStyles, Typography } from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import { routePaths } from "../../config/route-paths";
import { useTranslation } from "react-i18next";

const useStyle = makeStyles((theme) => ({
  termsLinks: {
    color: theme.palette.ePrimary?.base,
  },
  footerStyle:{
    position:"absolute",
    bottom:"0.4rem",
    [theme.breakpoints.up("sm")]: {
      left:"4.3rem",
    },
     [theme.breakpoints.down("sm")]: {
      left: '3rem !important',
      marginBottom: '0.5rem'
     },
  },
  powered:{
    fontSize:"6px",
    color:"#DDE6EE"
  }
}));

export default function E_Footer() {
  let classes = useStyle();
  let isTabletOrMobile = useMediaQuery({ maxWidth: 900 });
  const {t:labels} = useTranslation("label-E_NESCO_TERMS") ;
  const {t:content,ready:contentReady}=useTranslation("content-E_FOOTER")

  return (
    <div className={classes.footerStyle} >
    <Typography
      variant="caption"
    >
      {contentReady ? content("E_FOOTER_COPYRIGHT").answer : ""}<sub style={{color:'transparent'}}>{labels("E_POWEREDBY")}</sub>
      {/* {isTabletOrMobile ? <br /> : <>&emsp;</>} */}
      {/* <a href={routePaths.TERMS_POLICIES}>{labels("E_TERMS_TITLE")}</a> <span className={classes.powered}>{labels("E_POWEREDBY")}</span> */}
    </Typography>
    </div>
  );
}
